import PrintsFormInputs from './PrintsFormInputs'

export default PrintsFormInputs
